import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useMemo, createRef } from 'preact/compat';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import convertDataAttributes from '@widgets/shared/convertDataAttributes';
import FormField from '@widgets/EnquiryForm/components/FormField';
import { generateSchema } from '@enquiryForm/validation/generateSchema';
import generateDefaultValues from '@enquiryForm/validation/generateDefaultValues';
function Form(props) {
    const { fields, submissionMethod, submissionEndpoint } = props;
    const formRef = createRef();
    const formSchema = useMemo(() => generateSchema(fields), [fields]);
    const defaultValues = useMemo(() => generateDefaultValues(fields), [fields]);
    const form = useForm({
        mode: 'onChange',
        resolver: yupResolver(formSchema),
        defaultValues,
    });
    const { formState: { isValid, errors }, getValues } = form;
    return (_jsx(FormProvider, { ...form, children: _jsxs("form", { ref: formRef, method: submissionMethod ?? 'POST', action: submissionEndpoint, className: "form", autoComplete: "off", children: [fields.map(FormField), _jsx("div", { className: "form__actions", children: _jsx("button", { type: "submit", className: "btn", disabled: !isValid, children: "Submit" }) })] }) }));
}
function EnquiryForm(props) {
    const { dataset } = props;
    const formConfig = convertDataAttributes(dataset ?? {});
    return (_jsx(Form, { ...formConfig }));
}
export default EnquiryForm;
